var map = {
	"./decidim/avatar-multiuser.png": 24817,
	"./decidim/brands/facebook.svg": 25301,
	"./decidim/brands/google.svg": 34652,
	"./decidim/brands/twitter-x.svg": 42505,
	"./decidim/cc-badge.png": 30871,
	"./decidim/decidim-logo.svg": 76259,
	"./decidim/default-avatar.svg": 28311,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 75533,
	"./decidim/icons.svg": 950,
	"./decidim/pattern.png": 83797,
	"./decidim/placeholder-card-g.svg": 67002,
	"./decidim/placeholder-card-l.svg": 86238,
	"./decidim/placeholder.jpg": 95088,
	"./decidim/remixicon.symbol.svg": 59426,
	"./decidim/vendor/social-share-button/douban.svg": 47653,
	"./decidim/vendor/social-share-button/email.svg": 59846,
	"./decidim/vendor/social-share-button/facebook.svg": 76430,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 50402,
	"./decidim/vendor/social-share-button/hacker_news.svg": 37254,
	"./decidim/vendor/social-share-button/linkedin.svg": 62524,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 26357,
	"./decidim/vendor/social-share-button/pinterest.svg": 47936,
	"./decidim/vendor/social-share-button/reddit.svg": 72314,
	"./decidim/vendor/social-share-button/telegram.svg": 7915,
	"./decidim/vendor/social-share-button/tumblr.svg": 13448,
	"./decidim/vendor/social-share-button/twitter.svg": 99243,
	"./decidim/vendor/social-share-button/vkontakte.svg": 88225,
	"./decidim/vendor/social-share-button/wechat.svg": 27540,
	"./decidim/vendor/social-share-button/whatsapp.svg": 90860,
	"./decidim/vendor/social-share-button/x.svg": 49934,
	"./decidim/vendor/social-share-button/xing.svg": 9962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16178;